import React, { useEffect, useState } from "react";
import {
  CheckBox,
  DropdownBox,
  InputBox,
  SubmitButton,
  TextAreaBox,
  UploadBox,
} from "../../components/Input";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_URL } from "../../config";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import StateManagedSelect from "react-select";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const CreditAdd = () => {
  const [service, setService] = useState({});
  // const [segmentListOption, setSegmentList] = useState([]);
  const [editorContent, setEditorContent] = useState("");
  const [ratinaleEditorContent, setRationaleEditor] = useState("");
  const [webSiteEditorContent, setWebSiteEditorContent] = useState("");
  const [assetClassList, setAssetClassList] = useState([]);
  const [serviceImage, setServiceImage] = useState(null);
  const [rationaleFile, setRationaleFile] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [segmentListOption, setSegmentListOption] = useState([]);
  const [investmentHorizonList, setInvestmentHorizonList] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);
  const [callTypeList, setCallTypeList] = useState([]);
  const [instrumentsList, setInstrumentsList] = useState([]);
  const [volatilityList, setVolatilityList] = useState([]);
  const serviceApiOptions = [
    { value: "Intraday", label: "Intraday" },
    { value: "Single Stock", label: "Single Stock" },
    { value: "Derivative", label: "Derivative" },
  ];
  const [formValues, setFormValues] = useState({
    segid: "",
    service_name: "",
    service_api: "",
    service_description: "",
    is_free: 0, // 0/1 for boolean values
    activate: 0, // Changed from boolean to number (0/1)
    serviceSub: [],
    investment_horizon: "",
    percentage: "",
    price_type: "",
    stock_horizon: "",
    call_type: "",
    instruments: "",
    asset_class: "",
    volatility: "",
    mincap: "",
    tradetype: "",
    traderisk: "",
    traderturn: "",
    qty_min: "",
    activecount: "",
    min_investment: "",
    cagr: "",
    blog_url: "",
    lot_alloc: 0, // 0/1 for boolean values
    check_nse: 0, // 0/1 for boolean values
    check_bse: 0, // 0/1 for boolean values
    check_mcx: 0, // 0/1 for boolean values
    check_nfo: 0, // 0/1 for boolean values
    check_bfo: 0, // 0/1 for boolean values
    publish_performance: 0, // 0/1 for boolean values
    buy_call: "",
    sell_call: "",
    buy_comment: "",
    sell_comment: "",
    constituents: "",
    current_nav: "",
    portfolio_type: 0,
    service_type: 0,
    carparva_send: 0,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { id } = useParams();

  // const fetchServicesSegment = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get(`${API_URL}service`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     console.log("fetchServicesSegment", response);

  //     const formatteddata = response.data.data
  //       .filter((dt) => dt.type == 0)
  //       .map((dt) => ({
  //         value: dt.id,
  //         label: dt.segmentName,
  //       }));

  //     setSegmentList(formatteddata);
  //   } catch (error) {
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchDropdownData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}service`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // Defensive coding for backend structure
      const data = response.data.data || {};
console.log(data)
      // Segment options
      setSegmentListOption(
        (data.segments || [])
          .filter(dt => dt.type === 0)
          .map(dt => ({
            value: dt.id,
            label: dt.segmentName,
          }))
      );
      // Investment Horizon options
      setInvestmentHorizonList(data.investmentHorizonList || []);
      // Price Type options
      setPriceTypeList(data.priceTypeList || []);
      // Call Type options
      setCallTypeList(data.callTypeList || []);
      // Instruments options
      setInstrumentsList(data.instrumentsList || []);
      // Volatility options
      setVolatilityList(data.volatilityList || []);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };


  const fetchAssetClasses = async () => {
    try {
      const response = await axios.get(
        `${API_URL}notification/dropdown/asset-class`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setAssetClassList(response.data);
    } catch (error) {
      console.error("Error fetching asset classes:", error);
    }
  };

  const fetchServices = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}service/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setService(response.data.data);

      // Set form values directly when service data is fetched
      const serviceData = response.data.data.service;
      if (serviceData) {
        setFormValues((prevValues) => ({
          ...prevValues,
          segid: serviceData.segid ? String(serviceData.segid) : "",
          service_name: serviceData.service_name || "",
          service_api: serviceData.service_api || "",
          service_description: serviceData.service_description || "",
          is_free: serviceData.is_free ? 1 : 0, // Convert boolean to number
          activate: serviceData.activate,
          investment_horizon: serviceData.investment_period || "",
          percentage: serviceData.percentage !== undefined && serviceData.percentage !== null ? serviceData.percentage : "",
          price_type: serviceData.price_type || "",
          stock_horizon: serviceData.stock_horizon !== undefined && serviceData.stock_horizon !== null ? serviceData.stock_horizon : "",
          call_type: serviceData.call_type || "",
          instruments: serviceData.instruments || "",
          asset_class: serviceData.asset_class || "",
          volatility: serviceData.volatility || "",
          mincap: serviceData.mincap || "",
          tradetype: serviceData.tradetype || "",
          traderisk: serviceData.traderisk || "",
          tradereturn: serviceData.tradereturn || "",
          qty_min: serviceData.qty_min || "",
          activecount: serviceData.activecount || "",
          min_investment: serviceData.min_investment || "",
          cagr: serviceData.cagr || "",
          blog_url: serviceData.blog_url || "",
          lot_alloc: serviceData.lot_alloc || 0,
          check_nse: serviceData.check_nse ? 1 : 0,
          check_bse: serviceData.check_bse ? 1 : 0,
          check_mcx: serviceData.check_mcx ? 1 : 0,
          check_nfo: serviceData.check_nfo ? 1 : 0,
          check_bfo: serviceData.check_bfo ? 1 : 0,
          publish_performance: serviceData.publish_performance ? 1 : 0,
          buy_call: serviceData.buy_call || "",
          sell_call: serviceData.sell_call || "",
          buy_comment: serviceData.buy_comment || "",
          sell_comment: serviceData.sell_comment || "",
          constituents: serviceData.constituents || "",
          current_nav: serviceData.current_nav || "",
          carparva_send: serviceData.carparva_send ? 1 : 0,
        }));

        if (serviceData.description) {
          setEditorContent(serviceData.description);
        }
        if (serviceData.rationale_desc) {
          setRationaleEditor(serviceData.rationale_desc);
        }
        if (serviceData.description2) {
          setWebSiteEditorContent(serviceData.description2);
        }
      }

      // Set serviceSub
      if (response.data.data.serviceSub) {
        setFormValues((prevValues) => ({
          ...prevValues,
          serviceSub: response.data.data.serviceSub,
        }));
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchAssetClasses();
  //   fetchServicesSegment();
  //   if (id) {
  //     fetchServices(id);
  //   }
  // }, [id]);

  useEffect(() => {
    const loadAllData = async () => {
      try {
        await Promise.all([
          fetchAssetClasses(),
          fetchDropdownData(),
        ]);
        if (id) {
          await fetchServices(id);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setPageLoading(false);
      }
    };
    loadAllData();
  }, [id]);



  const handleEditorChange = (value) => {
    setEditorContent(value);
  };

  const handleRationaleEditorChange = (value) => {
    setRationaleEditor(value);
  };

  const handleWebsiteEditorChange = (value) => {
    setWebSiteEditorContent(value);
  };

  const handleServiceImageChange = (e) => {
    setServiceImage(e.target.files[0]);
  };

  const handleRationaleFileChange = (e) => {
    setRationaleFile(e.target.files[0]);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      segid: selectedValue,
    }));
  };

  const handleSubServiceInputChange = (e, id) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: prevValues.serviceSub.map((subService) =>
        subService.id === id ? { ...subService, [name]: value } : subService
      ),
    }));
  };

  const handleSubServiceSelectChange = (e, id) => {
    const selectedValue = e.target.value;
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: prevValues.serviceSub.map((subService) =>
        subService.id === id
          ? { ...subService, credits: selectedValue }
          : subService
      ),
    }));
  };

  // Handle checkbox change for sub-service
  const handleSubServiceCheckboxChange = (e, id) => {
    const { name, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: prevValues.serviceSub.map((subService) =>
        subService.id === id
          ? { ...subService, [name]: checked ? 1 : 0 }
          : subService
      ),
    }));
  };

  // Handle checkbox change for checkboxes that should be 0/1
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: checked ? 1 : 0,
    }));
  };

  // Handle is_free checkbox change (special case - needs to be 0/1)
  const handleIsFreeChange = (e) => {
    const { checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      is_free: checked ? 1 : 0,
    }));
  };

  // Add new sub-service (credits or monthly)
  const addSubService = (type) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: [
        ...prevValues.serviceSub,
        {
          id: Date.now(),
          credits: type === "credits" ? "" : null,
          credits_price: "",
          discount_price: "",
          productid: "",
          freepaid: 0,
          device_type: 0,
          stype: type === "credits" ? 0 : 1,
        },
      ],
    }));
  };

  // Delete sub-service
  const deleteSubService = (id) => {
    setFormValues((prevValues) => {
      // Find the sub-service to be deleted
      const updatedSubServices = prevValues.serviceSub.map((subService) => {
        if (subService.id === id) {
          // Set credits to 0 and mark as deleted for UI
          return {
            ...subService,
            credits: 0,
            credits_price: 0,
            discount_price: 0,
            isDeleted: true, // Mark as deleted to hide from UI
          };
        }
        return subService;
      });

      return {
        ...prevValues,
        serviceSub: updatedSubServices,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create FormData object for multipart/form-data
    const formData = new FormData();

    // Add all form values to FormData
    const formValuesToSend = {
      ...formValues,
      // Ensure numeric fields are properly converted
      segid: formValues.segid ? parseInt(formValues.segid) : 0,
      qty_min: parseInt(formValues.qty_min) || 0,
      mincap: formValues.mincap?.toString() || "",
      activecount: parseInt(formValues.activecount) || 0,
      min_investment: formValues.min_investment || "",
      cagr: formValues.cagr || "",
      blog_url: formValues.blog_url || "",
      traderturn: formValues.tradereturn || "",
      // Ensure checkboxes are 0 or 1
      check_nse: formValues.check_nse ? 1 : 0,
      check_bse: formValues.check_bse ? 1 : 0,
      check_mcx: formValues.check_mcx ? 1 : 0,
      check_nfo: formValues.check_nfo ? 1 : 0,
      check_bfo: formValues.check_bfo ? 1 : 0,
      publish_performance: formValues.publish_performance ? 1 : 0,
      lot_alloc: formValues.lot_alloc ? 1 : 0,
      activate: formValues.activate ? 1 : 0,
      is_free: formValues.is_free ? 1 : 0,
      carparva_send: formValues.carparva_send ? 1 : 0,
      // Set default values for required fields
      service_type: 0,
      portfolio_type: 0,
      current_nav: 0,
      asset_class: formValues.asset_class || 0,
      service_api: formValues.service_api || "",
      // Fix the field names to match DTO
      investment_horizon: formValues.investment_horizon || "",
      percentage: formValues.percentage !== "" ? formValues.percentage : 0,
      price_type: formValues.price_type || "",
      stock_horizon: formValues.stock_horizon !== "" ? Number(formValues.stock_horizon) : 0,
      call_type: formValues.call_type || "",
      instruments: formValues.instruments || "",
      volatility: formValues.volatility || "",
      constituents: formValues.constituents || "",
      // Add editor contents with proper fallbacks
      description: editorContent || "",
      description2: webSiteEditorContent || "",
      rationale_desc: ratinaleEditorContent || "",
    };

    // Ensure investment_period is set from investment_horizon
    formValuesToSend.investment_period = formValues.investment_horizon || "";

    // Add all form values to FormData
    Object.entries(formValuesToSend).forEach(([key, value]) => {
      if (key !== "serviceSub" && value !== undefined) {
        // Skip appending undefined values to avoid 'undefined' strings
        if (value !== undefined && value !== null) {
          // Convert boolean values to 1 or 0 for checkboxes
          if (typeof value === "boolean") {
            formData.append(key, value ? 1 : 0);
          } else {
            formData.append(key, value);
          }
        }
      }
    });

    // Handle sub_services
    const subServices = formValues.serviceSub.map((sub) => {
      // Check if id belongs to an existing sub-service or is a newly generated one (timestamp)
      const isExistingId =
        sub.id && Number.isInteger(sub.id) && sub.id < 1000000;

      if (isExistingId) {
        return {
          id: sub.id,
          credits: sub.credits,
          credits_price: sub.credits_price,
          discount_price: sub.discount_price,
          productid: sub.productid,
          freepaid: sub.freepaid,
          device_type: sub.device_type,
          stype: sub.stype,
        };
      } else {
        // For new sub-services, return all fields except id
        const { id, ...rest } = sub;
        return { ...rest };
      }
    });
    formData.append("sub_services", JSON.stringify(subServices));

    // Handle file uploads
    if (serviceImage) {
      formData.append("service_image", serviceImage);
    } else if (service?.service?.service_image) {
      // If editing and no new image is provided, keep the existing one
      formData.append("service_image", service.service.service_image);
    }

    if (rationaleFile) {
      formData.append("rationale_file", rationaleFile);
    } else if (service?.service?.rationale_file) {
      // If editing and no new file is provided, keep the existing one
      formData.append("rationale_file", service.service.rationale_file);
    }

    // Add ID if editing
    if (id) {
      formData.append("id", id);
    }

    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}service/save`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/research/Services");
      }
    } catch (error) {
      console.error("Error saving service:", error);
      showToast.error("There was an error saving the service");
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
      <div>
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0 mb-1">
            <span className="panel-title">
              {id ? "Edit " : "Add "}Credit Based Service
            </span>
          </div>
          <hr></hr>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="panel-body">
              <div className="row">
                {/* Segment Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="">Segment</label>
                  <StateManagedSelect
                    options={segmentListOption}
                    onChange={handleSelectChange}
                    value={
                      formValues.segid
                        ? segmentListOption.find(option => option.value == formValues.segid)
                        : null
                    }
                    placeholder="Select Segment"
                  />

                </div>

                {/* Service Name */}
                <div className="col-md-3">
                  <InputBox
                    label="Name of the Service"
                    fieldname="service_name"
                    placeholder="Enter Portfolio/Service Name"
                    value={formValues.service_name}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Investment Horizon */}
                <div className="col-md-3">
                  <label className="form-label">Investment Horizon</label>
                  <StateManagedSelect
                    options={investmentHorizonList}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        investment_horizon: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.investment_horizon
                        ? investmentHorizonList.find(
                          (option) => option.value == formValues.investment_horizon
                        )
                        : null
                    }
                    placeholder="Select Investment Horizon"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Volatility</label>
                  <StateManagedSelect
                    options={volatilityList}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        volatility: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.volatility
                        ? volatilityList.find(
                          (option) => option.value == formValues.volatility
                        )
                        : null
                    }
                    placeholder="Select Volatility"
                  />
                </div>
              </div>

              <div className="row mt-3">

                {/* Minimum Capital */}
                <div className="col-md-3">
                  <InputBox
                    label="Min Capital"
                    fieldname="mincap"
                    placeholder="Enter Min Capital"
                    value={formValues.mincap}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Trade Type */}
                <div className="col-md-3">
                  <InputBox
                    label="Trade Type"
                    fieldname="tradetype"
                    placeholder="Enter Trade Type"
                    value={formValues.tradetype}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Trade Risk */}
                <div className="col-md-3">
                  <InputBox
                    label="Trade Risk"
                    fieldname="traderisk"
                    placeholder="Enter Trade Risk"
                    value={formValues.traderisk}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Trade Return */}
                <div className="col-md-3">
                  <InputBox
                    label="Trade Return"
                    fieldname="tradereturn"
                    placeholder="Enter Trade Return"
                    value={formValues.tradereturn}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <InputBox
                    label="For Quantity Calculation"
                    fieldname="qty_min"
                    placeholder="Enter Quantity Calculation Value"
                    value={formValues.qty_min}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="Active Notification"
                    fieldname="activecount"
                    placeholder="Enter Active Notification Count"
                    value={formValues.activecount}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-3">
                  <InputBox
                    label="Blog URL"
                    fieldname="blog_url"
                    placeholder="Enter Blog URL"
                    value={formValues.blog_url || ""}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-3">
                  <CheckBox
                    label="Lot Allocation"
                    fieldname="lot_alloc"
                    checked={formValues.lot_alloc}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-3">
                  <CheckBox
                    label="Service Access Is Free"
                    fieldname="is_free"
                    checked={formValues.is_free === 1} // Convert number to boolean for checkbox
                    onChange={handleIsFreeChange} // Use special handler
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label>Service Image</label>
                  <input
                    type="file"
                    name="service_image"
                    onChange={handleServiceImageChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-4">
                  <label>Rationale File</label>
                  <input
                    type="file"
                    name="rationale_file"
                    onChange={handleRationaleFileChange}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="row">
                {/* Description */}
                <div className="col-md-12">
                  <TextAreaBox
                    label="Short Description"
                    fieldname="service_description"
                    placeholder="Enter Short Description"
                    value={formValues.service_description}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Description */}
                <div className="col-md-12">
                  <label htmlFor="">Description</label>
                  <ReactQuill
                    value={editorContent}
                    onChange={handleEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="">Description Website</label>
                  <ReactQuill
                    value={webSiteEditorContent}
                    onChange={handleWebsiteEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <InputBox
                    label="Buy - Why This Call"
                    fieldname="buy_call"
                    placeholder="Enter Buy Call"
                    value={formValues.buy_call}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <InputBox
                    label="Sell - Why This Call"
                    fieldname="sell_call"
                    placeholder="Enter Sell Call"
                    value={formValues.sell_call}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-6">
                  <TextAreaBox
                    label="Buy Comment"
                    fieldname="buy_comment"
                    placeholder="Enter Buy Description for Research"
                    value={formValues.buy_comment}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-6">
                  <TextAreaBox
                    label="Sell Comment"
                    fieldname="sell_comment"
                    placeholder="Enter Sell Description for Research"
                    value={formValues.sell_comment}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="row">
                {/* Checkboxes for Exchanges */}
                <div className="col-md-2">
                  <CheckBox
                    label="NSE"
                    fieldname="check_nse"
                    checked={formValues.check_nse}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-2">
                  <CheckBox
                    label="BSE"
                    fieldname="check_bse"
                    checked={formValues.check_bse}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-2">
                  <CheckBox
                    label="MCX"
                    fieldname="check_mcx"
                    checked={formValues.check_mcx}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-2">
                  <CheckBox
                    label="NFO"
                    fieldname="check_nfo"
                    checked={formValues.check_nfo}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-2">
                  <CheckBox
                    label="BFO"
                    fieldname="check_bfo"
                    checked={formValues.check_bfo}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>

              <div className="row">
                {/* Activate and Publish Performance */}
                <div className="col-md-4">
                  <CheckBox
                    label="Set Active"
                    fieldname="activate"
                    checked={formValues.activate}
                    onChange={handleCheckboxChange}
                  />
                </div>
                <div className="col-md-4">
                  <CheckBox
                    label="Publish Performance"
                    fieldname="publish_performance"
                    checked={formValues.publish_performance}
                    onChange={handleCheckboxChange}
                  />
                </div>

                <div className="col-md-7 mb-2">
                  <label htmlFor="">Service Rationale Description</label>
                  <ReactQuill
                    value={ratinaleEditorContent}
                    onChange={handleRationaleEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>

                <div className="col-md-3 mt-5">
                  <a
                    href={service.rationale_file}
                    download
                    className="text-primary"
                  >
                    Download Rationale File <i className="ti ti-download"></i>
                  </a>
                </div>
              </div>

              {/* Carparva Fields Section */}
              <div className="panel-heading border-0 mb-1 px-0 mt-3">
                <span className="panel-title">Carparva Fields</span>
              </div>
              <hr />
              <div className="row mt-3 mb-4">
                {/* Service API Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Service API</label>
                  <StateManagedSelect
                    options={serviceApiOptions}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        service_api: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.service_api
                        ? serviceApiOptions.find(
                            (option) => option.value === formValues.service_api
                          ) || { value: formValues.service_api, label: formValues.service_api }
                        : null
                    }
                    placeholder="Select Service API"
                    isClearable
                  />
                </div>

                {/* Instruments Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Instruments</label>
                  <StateManagedSelect
                    options={instrumentsList}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        instruments: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.instruments
                        ? instrumentsList.find(
                            (option) => option.value === formValues.instruments
                          ) || { value: formValues.instruments, label: formValues.instruments }
                        : null
                    }
                    placeholder="Select Instruments"
                    isClearable
                  />
                </div>

                {/* Price Type Dropdown */}
                <div className="col-md-3">
                  <label className="form-label">Price Type</label>
                  <StateManagedSelect
                    options={priceTypeList}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        price_type: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.price_type
                        ? priceTypeList.find(
                            (option) => option.value === formValues.price_type
                          ) || { value: formValues.price_type, label: formValues.price_type }
                        : null
                    }
                    placeholder="Select Price Type"
                    isClearable
                  />
                </div>

                {/* Percentage Decimal field */}
                <div className="col-md-3">
                  <InputBox
                    label="Percentage For Price Range"
                    fieldname="percentage"
                    type="number"
                    jsScript={{ step: "0.01" }}
                    placeholder="Enter Percentage"
                    value={formValues.percentage}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Call Type Dropdown */}
                <div className="col-md-3 mt-3">
                  <label className="form-label">Call Type</label>
                  <StateManagedSelect
                    options={callTypeList}
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        call_type: selected ? selected.value : "",
                      }))
                    }
                    value={
                      formValues.call_type
                        ? callTypeList.find(
                            (option) => option.value === formValues.call_type
                          ) || { value: formValues.call_type, label: formValues.call_type }
                        : null
                    }
                    placeholder="Select Call Type"
                    isClearable
                  />
                </div>

                {/* Stock Horizon Number Field */}
                <div className="col-md-3 mt-3">
                  <InputBox
                    label="Stock Horizon In Days"
                    fieldname="stock_horizon"
                    type="number"
                    placeholder="Enter Stock Horizon"
                    value={formValues.stock_horizon}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="col-md-2 mt-4">
                  <CheckBox
                    label="CARPARVA SEND"
                    fieldname="carparva_send"
                    checked={formValues.carparva_send === 1 || formValues.carparva_send === true}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>

              {/* Sub-services table */}
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Credits</th>
                      <th>Price</th>
                      <th>Discount Price</th>
                      <th>Product ID</th>
                      <th>Make Free</th>
                      <th>
                        Device Type <br />
                        (is ios)
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formValues.serviceSub
                      .filter((sub) => !sub.isDeleted)
                      .map((sub) => (
                        <tr key={sub.id}>
                          <td>
                            {sub.stype ? (
                              <>
                                <select
                                  name="credits"
                                  onChange={(e) =>
                                    handleSubServiceSelectChange(e, sub.id)
                                  }
                                  value={sub.credits || ""}
                                >
                                  <option value="">Select Option</option>
                                  {[
                                    { value: 1, label: "1 Month" },
                                    { value: 3, label: "3 Months" },
                                    { value: 6, label: "6 Months" },
                                    { value: 12, label: "12 Months" },
                                    { value: 100, label: "Lifetime" },
                                  ].map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </>
                            ) : (
                              <input
                                type="number"
                                name="credits"
                                value={sub.credits}
                                onChange={(e) =>
                                  handleSubServiceInputChange(e, sub.id)
                                }
                                placeholder="Enter Credits"
                              />
                            )}
                          </td>
                          <td>
                            <input
                              type="number"
                              name="credits_price"
                              value={sub.credits_price}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Price"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              name="discount_price"
                              value={sub.discount_price}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Discount Price"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="productid"
                              value={sub.productid}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Product Id"
                            />
                          </td>
                          <td>
                            <CheckBox
                              label=""
                              fieldname="freepaid"
                              checked={sub.freepaid === 1} // Convert number to boolean
                              onChange={(e) =>
                                handleSubServiceCheckboxChange(e, sub.id)
                              }
                              id={sub.id}
                            />
                          </td>
                          <td>
                            <CheckBox
                              label=""
                              fieldname="device_type"
                              checked={sub.device_type === 1} // Convert number to boolean
                              onChange={(e) =>
                                handleSubServiceCheckboxChange(e, sub.id)
                              }
                              id={sub.id}
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-danger"
                              onClick={() => deleteSubService(sub.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => addSubService("credits")}
                  >
                    Add Credits
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ marginLeft: "10px" }}
                    onClick={() => addSubService("monthly")}
                  >
                    Add Monthly
                  </button>
                </div>
              </div>

              <SubmitButton
                pageBack="/research/Services"
                handleSubmit={handleSubmit}
                loading={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreditAdd;
